module.exports = __webpack_public_path__ + "static/img/amd2.deb6a48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/amd2.png
// module id = Qvuv
// module chunks = 1